// extracted by mini-css-extract-plugin
export default {"deletePopoverHeader":"styles_deletePopoverHeader__M5W4E","deletePopoverContent":"styles_deletePopoverContent__tHA0R","deletePopoverFooter":"styles_deletePopoverFooter__931o7"};